// Response Times Chart Component
// Shows how response time affects conversion rates

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { COLORS } from './analyticsConstants';

const ResponseTimesChart = ({ responseTimes }) => {
  if (!responseTimes) return null;

  return (
    <Card className="border-slate-200" data-testid="response-times">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-teal-500" />
          Response Time Impact
        </CardTitle>
        <CardDescription>How response time affects conversion rates</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          <div className="text-center p-4 bg-slate-50 rounded-lg">
            <p className="text-3xl font-bold text-slate-900">{responseTimes.avg_response_hours}h</p>
            <p className="text-sm text-slate-500">Avg Response Time</p>
          </div>
          <div className="text-center p-4 bg-emerald-50 rounded-lg">
            <p className="text-3xl font-bold text-emerald-600">{responseTimes.avg_converted_response_hours}h</p>
            <p className="text-sm text-slate-500">Avg for Converted</p>
          </div>
          <div className="text-center p-4 bg-amber-50 rounded-lg">
            <p className="text-3xl font-bold text-amber-600">{responseTimes.avg_not_converted_response_hours}h</p>
            <p className="text-sm text-slate-500">Avg for Not Converted</p>
          </div>
        </div>
        
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <BarChart data={responseTimes.buckets}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Legend />
              <Bar dataKey="count" name="Total" fill={COLORS.primary} radius={[4, 4, 0, 0]} />
              <Bar dataKey="converted" name="Converted" fill={COLORS.success} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        
        <p className="text-sm text-slate-500 mt-4 text-center">
          Faster response times correlate with higher conversion rates
        </p>
      </CardContent>
    </Card>
  );
};

export default ResponseTimesChart;
